const lineNamesFromLine = (line) => {
  let lineName = ''
  if (line.name) {
    lineName = {
      name: line.name,
      backgroundColor: line.color,
      textColor: line.textColor,
    }
  }
  return lineName
}

export {
  lineNamesFromLine,
}
